import { render, staticRenderFns } from "./CourseScheduleRowComponent.vue?vue&type=template&id=3b242e8a"
import script from "./CourseScheduleRowComponent.vue?vue&type=script&lang=js"
export * from "./CourseScheduleRowComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports